import { ICellRendererParams } from 'ag-grid-community'
import { PLACEHOLDER } from 'components/column-renderers'
import { QueryLinkedArticlesCell } from '../components/QueryTablePage/QueryLinkedArticlesCell'

export function linkedArticlesCellRenderer(
  props: ICellRendererParams<{ linkedArticlesCount?: number; id: number }>,
) {
  const count = props.data?.linkedArticlesCount
  const queryId = props.data?.id

  if (!count || !queryId) return PLACEHOLDER

  return <QueryLinkedArticlesCell queryId={queryId} count={count} />
}
